// Template220: Kuala Lumpur - Día 1 Iconos (Page3)
// Portada Petronas, intro, Torres Petronas + SabiasQue, Skybridge box + tip, KLCC Park + SabiasQue, Suria KLCC.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template220 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const titleOverlay = page?.texts?.[1]?.content;
	const intro = page?.texts?.[2]?.content;
	const block1Title = page?.texts?.[3]?.content;
	const block1Body = page?.texts?.[4]?.content;
	const tipReserva = page?.texts?.[5]?.content;
	const skybridgeBox = page?.texts?.[6]?.content;
	const block2Title = page?.texts?.[7]?.content;
	const block2Body = page?.texts?.[8]?.content;
	const block3Title = page?.texts?.[9]?.content;
	const block3Body = page?.texts?.[10]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const portadaSticker = getImageSrc("portada-sticker");
	const img1 = getImageSrc("img1");
	const img2Sticker = getImageSrc("img2-sticker");
	const img3 = getImageSrc("img3");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const actualHeaderColor = headerBackgroundColor || "#2E7D5B";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{portadaImage && (
				<Box data-block-id="image-0" sx={{ position: "relative" }}>
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
					{titleOverlay && (
						<Box
							component="h1"
							sx={{
								fontSize: isSmallScreen ? 28 : 32,
								textAlign: "center",
								position: "absolute",
								bottom: 0,
								margin: 1.25,
								left: 20,
								color: "#fff",
								textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
							}}
						>
							{titleOverlay}
						</Box>
					)}
					{portadaSticker && (
						<Box
							component="img"
							src={portadaSticker}
							alt=""
							sx={{ width: 90, position: "absolute", bottom: 60, left: 20 }}
						/>
					)}
				</Box>
			)}

			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					paddingBottom: "5px",
					position: "relative",
				}}
			>
				{intro && (
					<Box
						component="p"
						sx={{ ...estiloP, color: "#333", marginTop: "-6px" }}
					>
						{intro}
					</Box>
				)}

				<Box
					data-block-id="text-2"
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: 1.5,
						marginTop: 1.25,
					}}
				>
					{/* Block1: Torres Petronas */}
					<Box data-block-id="text-3" sx={{ display: "flex", gap: 2, position: "relative" }}>
						{img1 && (
							<Box
								component="img"
								src={img1}
								alt=""
								sx={{
									width: "40%",
									height: 110,
									objectFit: "cover",
									borderRadius: "12px",
								}}
							/>
						)}
						{sabiasQue[0] && (
							<Box sx={{ position: "absolute", top: 0, left: "33%" }}>
								<SabiasQue
									icono={sabiasQue[0].icono}
									texto={sabiasQue[0].texto}
								/>
							</Box>
						)}
						{sabiasQue[1] && (
							<Box sx={{ position: "absolute", top: 40, left: "33%" }}>
								<SabiasQue
									icono={sabiasQue[1].icono}
									texto={sabiasQue[1].texto}
								/>
							</Box>
						)}
						<Box sx={{ width: "60%" }}>
							{block1Title && (
								<Box component="h3" sx={estiloH3}>
									{block1Title}
								</Box>
							)}
							{block1Body && (
								<Box component="p" sx={estiloP}>
									{block1Body}
								</Box>
							)}
						</Box>
					</Box>

					{/* Block2: Skybridge + tip */}
					<Box data-block-id="text-4" sx={{ display: "flex", gap: 2, position: "relative" }}>
						{img2Sticker && (
							<Box
								component="img"
								src={img2Sticker}
								alt=""
								sx={{ width: 100, position: "absolute", bottom: -30, left: 0 }}
							/>
						)}
						{tipReserva && (
							<Box
								sx={{
									position: "absolute",
									bottom: 50,
									left: isSmallScreen ? 0 : 10,
									backgroundColor: "#fff8db",
									border: "2px solid #f5c400",
									borderRadius: "16px 16px 16px 0px",
									padding: "10px 12px",
									fontSize: 11,
									color: "#444",
									boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
									maxWidth: 140,
									zIndex: 6,
								}}
							>
								{tipReserva}
							</Box>
						)}
						{skybridgeBox && (
							<Box
								sx={{
									backgroundColor: "#dee7e3",

									borderRadius: "12px",
									padding: "10px 12px",
									marginLeft: "140px",
								}}
							>
								<Box component="p" sx={{ ...estiloP }}>
									{skybridgeBox}
								</Box>
							</Box>
						)}
					</Box>

					{/* Block3: KLCC Park */}
					<Box data-block-id="text-5" sx={{ display: "flex", gap: 2, position: "relative" }}>
						{img3 && (
							<Box
								component="img"
								src={img3}
								alt=""
								sx={{
									width: "40%",
									height: 110,
									objectFit: "cover",
									borderRadius: "12px",
								}}
							/>
						)}
						{sabiasQue[2] && (
							<Box sx={{ position: "absolute", top: 0, left: "33%" }}>
								<SabiasQue
									icono={sabiasQue[2].icono}
									texto={sabiasQue[2].texto}
								/>
							</Box>
						)}
						{sabiasQue[3] && (
							<Box sx={{ position: "absolute", top: 40, left: "33%" }}>
								<SabiasQue
									icono={sabiasQue[3].icono}
									texto={sabiasQue[3].texto}
								/>
							</Box>
						)}
						<Box sx={{ width: "60%" }}>
							{block2Title && (
								<Box component="h3" sx={estiloH3}>
									{block2Title}
								</Box>
							)}
							{block2Body && (
								<Box component="p" sx={estiloP}>
									{block2Body}
								</Box>
							)}
						</Box>
					</Box>

					{/* Block4: Suria KLCC */}
					{(block3Title || block3Body) && (
						<Box
							data-block-id="text-6"
							sx={{
								backgroundColor: "#dee7e3",
								border: "2px solid #2E7D5B",
								borderRadius: "12px",
								padding: "8px 14px",
								fontSize: "13px",
								color: "#444",
								marginTop: -0.5,
								marginBottom: isSmallScreen ? 2 : 0,
							}}
						>
							{block3Title && (
								<Box component="h3" sx={{ ...estiloH3, color: "#2e7d5b" }}>
									{block3Title}
								</Box>
							)}
							{block3Body && (
								<Box component="p" sx={estiloP}>
									{block3Body}
								</Box>
							)}
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template220.thumbnail = "/images/template-1.png";
export default Template220;
